module.exports = __webpack_public_path__ + "img/Revisi-Atas-2.71d80d13.png";